import { render, staticRenderFns } from "./PropertyPaginator.vue?vue&type=template&id=4d5216f2&scoped=true"
import script from "./PropertyPaginator.vue?vue&type=script&lang=js"
export * from "./PropertyPaginator.vue?vue&type=script&lang=js"
import style0 from "./PropertyPaginator.vue?vue&type=style&index=0&id=4d5216f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5216f2",
  null
  
)

export default component.exports